import { c as _c } from "react/compiler-runtime";
import { faEnvelope, faMapMarker, faPhone } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Avatar } from 'shared/avatar';
import { Box, Flex, Grid } from 'shared/grid';
import { CroppedText, Heading, Link } from 'shared/typography';
import { useLocationId } from '../../hooks';
import { useAppSelector } from '../../store';
import { BookStepHeading } from '../shared';
const ContactDetails = t0 => {
  const $ = _c(9);
  const {
    location
  } = t0;
  const [showEmail, setShowEmail] = React.useState(false);
  const [showNumber, setShowNumber] = React.useState(false);
  let t1;
  if ($[0] !== location.email || $[1] !== showEmail) {
    t1 = location.email && <Box sx={{
      whiteSpace: "nowrap"
    }}><FontAwesomeIcon icon={faEnvelope} />{" "}{showEmail ? <Link href={`mailto:${location.email}`}>{location.email}</Link> : <Link onClick={() => setShowEmail(true)} as="button" type="button">Email us</Link>}</Box>;
    $[0] = location.email;
    $[1] = showEmail;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== location.tel || $[4] !== showNumber) {
    t2 = location.tel && <Box sx={{
      whiteSpace: "nowrap"
    }}><FontAwesomeIcon icon={faPhone} />{" "}{showNumber ? <Link href={`tel:${location.tel}`}>{location.tel}</Link> : <Link as="button" type="button" onClick={() => setShowNumber(true)}>Call us</Link>}</Box>;
    $[3] = location.tel;
    $[4] = showNumber;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
const LocationsView = () => {
  const $ = _c(21);
  const [locationId] = useLocationId();
  const business = useAppSelector(_temp);
  const locationData = useAppSelector(_temp2);
  let t0;
  if ($[0] !== locationData) {
    t0 = Object.values(locationData).filter(_temp3);
    $[0] = locationData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== business.id || $[3] !== t0) {
    t1 = t0.filter(l_0 => l_0.business_id === business.id);
    $[2] = business.id;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const locations = t1;
  const t2 = "/" + (locationId ? `?lid=${locationId}` : "");
  let t3;
  if ($[5] !== business.description || $[6] !== locations.length) {
    t3 = business.description || locations.length == 1 ? <FormattedMessage id="About" defaultMessage="About" /> : <FormattedMessage id="Locations" defaultMessage="Locations" />;
    $[5] = business.description;
    $[6] = locations.length;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <BookStepHeading backTo={t2}>{t3}</BookStepHeading>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== business.description) {
    t5 = business.description && <CroppedText>{business.description.replace("\n\n", "\n").split("\n").map(_temp4)}</CroppedText>;
    $[11] = business.description;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <Grid>{t4}{t5}</Grid>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== locations) {
    t7 = locations.map((location, idx_0) => <Flex key={idx_0} flexWrap="wrap" sx={{
      gap: 6
    }}><Link rel="noopener noreferrer" target={location.is_virtual ? null : "_blank"} href={location.is_virtual ? "#" : `https://maps.google.com/maps?&z=16&q=${location.gps[0]}+${location.gps[1]}&ll=${location.gps[0]}+${location.gps[1]}`}><Avatar size={100} image={location.is_virtual ? null : `https://maps.google.com/maps/api/staticmap?key=${__GOOGLE_MAPS_KEY__}&center=${location.gps[0]},${location.gps[1]}&zoom=14&size=150x150&sensor=false&markers=color:red|${location.gps[0]},${location.gps[1]}`} name={location.name} icon={faMapMarker} /></Link><Box><Grid key={idx_0} gridGap={2}>{locations.length > 1 && <Heading fontSize={3} as="h3">{location.name}</Heading>}{location.is_virtual ? <ContactDetails location={location} /> : <Grid gridGap={2}><Box>{[...(location.street_address || "").split("\n"), location.city, location.postal_code, location.province].map(_temp5)}</Box><ContactDetails location={location} /></Grid>}</Grid></Box></Flex>);
    $[16] = locations;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <><Grid gridGap={8}>{t6}{t7}</Grid></>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
export default LocationsView;
function _temp(state) {
  return state.businesses.data[state.public.businessId];
}
function _temp2(state_0) {
  return state_0.locations.data;
}
function _temp3(l) {
  return !l.is_deleted;
}
function _temp4(line, idx) {
  return line ? <Box as="p" mb="1em" key={idx} data-sentry-element="Box" data-sentry-component="_temp4" data-sentry-source-file="component.tsx">{line}</Box> : <br key={idx} data-sentry-component="_temp4" data-sentry-source-file="component.tsx" />;
}
function _temp5(line_0, idx_1) {
  return <div key={idx_1} data-sentry-component="_temp5" data-sentry-source-file="component.tsx">{line_0}</div>;
}